<template>
   <b-container>
       <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
			<h3>Customer Satisfaction Index (CSI)</h3><hr>
            </b-col>
		</b-row>
        <b-row>
            <b-col>
                <br>
                
            </b-col>
        </b-row>
       
            <b-form action="createNewCSI" id="addCSI" method="get" v-on:submit.prevent >
                
                   
                    <br><b>Company</b><br>
					<select class="form-control" id="selectCompany" name="Company" style="overflow:scroll;" @change="selectCompanyChange" v-model="idCompany">
						<option disabled selected value="-1"> -- Select a company -- </option>
						<option v-for="company in companies"  v-bind:key="company.idCompany" :value="company.idCompany" >{{company.CompanyName}}</option>		
						
					</select><br>
                    <div v-if="idCompany > 0">
					<br><b>Site</b><br>
					<select class="form-control" id="selectClient" name="Client" style="overflow:scroll;"  v-model="idSite">
						<option disabled selected value="-1"> -- Select a site -- </option>
					    <option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}}</option>		
						
					</select><br>
                    </div>
					<b>Date</b>
                    <datetime v-model="date"></datetime><br>
					Select the happiness level of the client
					<select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="selectedCSIndex">
                        <option disabled selected value="-1"> -- Select Happy level -- </option>
                        <option v-for="csi in CSIndex"  v-bind:key="csi.idCSIndex" :value="csi.idCSIndex" >{{csi.CSIndexDescription}}</option>
					</select>
                    <b>Note :</b><textarea   name="note" id="note" rows="4" class="form-control" v-model="note"></textarea ><br><br>
			  
					<input type="submit" value="Submit Information" class="btn btn-primary" id="submitbtn" style="width:100%;" @click="submit">
               
            </b-form>        
        
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
   </b-container>
</template>
<script type="text/javascript">
  import axios from 'axios';
  import moment from 'moment';

  export default {
    
  data: () => ({
      companies : [],
      sites : [],
      idSite : -1,
      idCompany : -1,
      date : null,
      CSIndex : [],
      selectedCSIndex : -1,
      note : null

  }),
  methods: {
      submit : function()
      {
          // Do validation
        let validObject = true;
        let mainObject = this;
        
        
        switch ( true )
        {
            case  ( (mainObject.idCompany == null)||( mainObject.idCompany < 1 ))  : 
                validObject = false;
                mainObject.showAlert("Please select a company.",2000,false);
                break;
            case  ( (mainObject.idSite == null)||( mainObject.idSite < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a site.",2000,false);
                break;
            case  ( (mainObject.note == null)||( mainObject.note == ""))  : 
                validObject = false;
                mainObject.showAlert("Please fill in note section.",2000,false);
                break;
            case  ( (mainObject.selectedCSIndex == null)||( mainObject.selectedCSIndex < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a satisfaction index.",2000,false);
                break;
            default : validObject = true;
        }
        if ( validObject )
        {
            axios.get(localStorage.getItem('ticketCopURL') +'/insertCSI', {
                params: {
                    employee : localStorage.getItem('employee'),
                    idSite : mainObject.idSite,
                    date : mainObject.date,
                    CSIndex : mainObject.selectedCSIndex,
                    note : mainObject.note,
                    idCompany : mainObject.idCompany
                },
                 headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                console.log(response.data);
                if ( response.data.status == "Success")
                {
                    console.log(response.data);
                    ///console.log("Travel Ticket number "+data.idTicket+" was created. For you convienance this ticket number was emailed to the travel agent. No booking has been made yet. Please follow up with the travel agent to arrange your travel. ")
                    let text = "CSI was successfully created."
                    mainObject.$swal.fire(text).then((result) => {
                        console.log(result);
                        mainObject.$router.go(-1);
                        
                    })
                    //mainObject.showAlert(text,2000,false);
                }
                else
                {
                    console.log("Error was not able to insert CSI info");
                    mainObject.showAlert("Error was not able to insert CSI info.",2000,false);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
         
                console.log("Done inserting ticket");
            });
        }
        else
        {
            console.log("Failed Validation");
        }
      }
      ,

      showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
      },

      selectCompanyChange : function()
      {
          let self = this;
          axios.get(localStorage.getItem('ticketCopURL') +'/getSite', {
            params: {
                idCompany : self.idCompany
            
            },
            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            self.sites = response.data;
            //console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
            
        });// end of axios call

      }

  },
  created: function () {
        var objectMain = this;
        objectMain.date = moment().toISOString();
        axios.get(localStorage.getItem('ticketCopURL') +'/getCompanies', {
            params: {
            
            },
            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            objectMain.companies = response.data;
            //console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
            
        });// end of axios call
        axios.get(localStorage.getItem('ticketCopURL') +'/getSatisfactionIndex', {
            params: {
            
            },
            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            objectMain.CSIndex = response.data;
            //console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
            
        });// end of axios call

  }

  }
</script>


